"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(theme) {
  return {
    container: {
      display: 'flex'
    },
    pane: {
      padding: '0 20px 0 20px',
      borderRight: "1px solid ".concat(theme.palette.primary.icon),
      '&:first-child': {
        paddingLeft: 0
      },
      '&:last-child': {
        paddingRight: 0,
        borderStyle: 'none'
      }
    }
  };
};

exports.default = _default;